import { Component } from "react";
import useAxiosInterceptors from '../config/axios-config';
import { toast } from 'react-toastify';
import HeaderComponent from "../header";

export default class TestSignature extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pdfbase64: "",
            certificateList: [],
            signatureList: [],
            show: false,
            setSelectedFile: null,
            certificateName: '',
            certificatePassword: '',
            showDelete: false,
            selectedCertificate: null,
            selectedSignature: null,
            stage: null,
            loading: false,
            isPdfSelected: false
        };
    };
    componentDidMount() {
        this.loadCertificates();
    }

    loadCertificates = () => {
        this.setState({
            loading: true
        });
        useAxiosInterceptors.get("/app/cert/v1/all", {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
                this.state.certificateList = res.data;
                this.selectedCertificate = res.data.length > 0 ? res.data[0].certificateId : null;
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                //Hide loader here
                this.setState({
                    show: false,
                    stage: null,
                    selectedCertificate: null,
                    loading: false
                });

                this.loadSignatures();
            });
    }

    loadSignatures = () => {
        this.setState({
            loading: true
        });
        useAxiosInterceptors.get("/app/signature/v1/all", {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
                this.state.signatureList = res.data;
                this.selectedSignature = res.data.length > 0 ? res.data[0].signatureId : null;
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                //Hide loader here
                this.setState({
                    show: false,
                    stage: null,
                    selectedSignature: null,
                    loading: false
                });
            });
    }

    useAxiosLoader(axiosInstance) {
        const [loading] = axiosInstance
    }

    changeCertificate = (event) => {
        this.selectedCertificate = event.target.value;
        this.setState({ selectedCertificate: event.target.value });
    }

    changeSignature = (event) => {
        console.log(event.target.value);
        this.selectedSignature = event.target.value;
        this.setState({ selectedSignature: event.target.value });
    }

    setPdfbase64 = (e) => {
        const file = e.target.files[0];
        if (!file) {
            this.setState({ isPdfSelected: false });
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file); // Converts file to base64 string

        reader.onload = () => {
            this.pdfbase64 = reader.result.replaceAll("data:application/pdf;base64,", ""); // ✅ result contains the Base64 string
            this.setState({ isPdfSelected: true });
            console.log(this.pdfbase64)
        };

        reader.onerror = (error) => {
            console.error("Error converting file:", error);
        };
    }

    signPdf = () => {

        this.setState({
            loading: true
        });
        useAxiosInterceptors.post("/app/common/v1/sign", {
            pdf: this.pdfbase64,
            isVisible: true,
            signatureId: this.selectedSignature,
            certificateId: this.selectedCertificate
        })
            .then((res) => {
                console.log(res);
                // window.open("data:application/pdf," + encodeURI(res.data.signedPdf));
                let pdfWindow = window.open("");
                pdfWindow.document.title = "Signed PDF";
                pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(res.data.signedPdf) + "'></iframe>")
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                //Hide loader here
                this.setState({
                    show: false,
                    stage: null,
                    selectedSignature: null,
                    selectedCertificate: null,
                    loading: false
                });
            });
    }

    render() {
        const { pdfbase64 } = this.state;
        const { selectedCertificate } = this.state;
        const { selectedSignature } = this.state;
        const { loading } = this.state;
        const { certificateList } = this.state;
        const { signatureList } = this.state;
        return (
            <div>
                <HeaderComponent />
                {loading ?
                    <>
                        <div className="overlay">
                            <div className="overlay__inner">
                                <div className="overlay__content">
                                    <span className="spinner"></span>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="container mt-5">
                            <div className="col-lg-8 offset-lg-2">
                                <div class="alert alert-primary" role="alert">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <label className="text-bold">Choose Certificate</label>
                                            <select class="form-select mt-2"
                                                aria-label="Default select example"
                                                onChange={this.changeCertificate}
                                            >
                                                {certificateList.map(({ certificateId, certificateName }, index) => <option value={certificateId} >{certificateName}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-lg-4">
                                            <label className="text-bold">Choose Signature</label>
                                            <select class="form-select mt-2"
                                                aria-label="Default select example 7"
                                                onChange={this.changeSignature}
                                            >
                                                {signatureList.map(({ signatureId, name }, index) => <option value={signatureId} >{name}</option>)}
                                            </select>
                                        </div>

                                        <div className="col-lg-4">
                                            <label className="text-bold">Choose PDF</label>
                                            <input className="form-control mt-2" type="file" accept="pdf" onChange={this.setPdfbase64}></input>
                                        </div>
                                        <div className="col-lg-4 mt-4">
                                            <button className="btn btn-sm btn-primary"
                                                onClick={this.signPdf}
                                                disabled={!this.state.isPdfSelected} // ✅ Disable until PDF is selected
                                            >
                                                Sign PDF

                                            </button>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </>
                }
            </div>
        );
    }
}
